import WineGlassIcon from './icons/WineGlassIcon';

/**
 * LoadingSpinner - Componente de loading com animação de taça de vinho
 *
 * Props:
 * @param {string} message - Mensagem opcional a ser exibida (default: "Carregando...")
 * @param {boolean} fullScreen - Se true, ocupa tela inteira (default: true)
 * @param {string} size - Tamanho do spinner: 'sm', 'md', 'lg' (default: 'md')
 */
const LoadingSpinner = ({
  message = 'Carregando...',
  fullScreen = true,
  size = 'md'
}) => {
  const sizes = {
    sm: 'w-8 h-8',
    md: 'w-16 h-16',
    lg: 'w-24 h-24'
  };

  const spinnerSize = sizes[size] || sizes.md;

  const content = (
    <div className="flex flex-col items-center justify-center gap-6">
      {/* Spinner com animação de pulse e rotate */}
      <div className="relative">
        {/* Círculo externo girando */}
        <div className={`${spinnerSize} border-4 border-wine-gold/20 rounded-full`} />
        <div
          className={`${spinnerSize} border-4 border-wine-gold border-t-transparent rounded-full animate-spin absolute top-0 left-0`}
          style={{ animationDuration: '1s' }}
        />

        {/* Ícone de taça no centro com pulse */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 animate-pulse">
          <div style={{ transform: 'scale(0.5)' }}>
            <WineGlassIcon />
          </div>
        </div>
      </div>

      {/* Mensagem */}
      {message && (
        <div className="text-center">
          <p className="text-wine-gold text-lg font-medium animate-pulse">
            {message}
          </p>
          <div className="flex gap-1 justify-center mt-2">
            <span className="w-2 h-2 bg-wine-gold rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
            <span className="w-2 h-2 bg-wine-gold rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
            <span className="w-2 h-2 bg-wine-gold rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
          </div>
        </div>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-wine-dark via-[#1e1a2e] to-wine-dark">
        {content}
      </div>
    );
  }

  return content;
};

export default LoadingSpinner;
